import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  getTeamMembersRequest,
  getTeamMembersSuccess,
  getTeamMembersFailure,
} from '../reducers/teamMembers';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/getTeamMembers`;

function* getTeamMembersAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?userId=${userId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerGetTeamMembersSaga() {
  try {
    const response = yield call(getTeamMembersAxios);
    const responseFromMessageContent = response.data;

    if (response.status === 200) {
      yield put(getTeamMembersSuccess(responseFromMessageContent));
    }
    if (response.status === 500) {
      yield put(getTeamMembersFailure(responseFromMessageContent));
    }
  } catch (error) {
    yield put(getTeamMembersFailure(error));
  }
}

export function* watcherGetTeamMembersSaga() {
  yield takeLatest(getTeamMembersRequest().type, workerGetTeamMembersSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/get_teamMembers.js